<template>
  <v-app-bar app>
    <v-img
      alt="Adobe"
      class="shrink mr-2 logo"
      contain
      src="../assets/adobe-icon.png"
      transition="scale-transition"
      width="40"
    />
    <div>Adobe Launch Viewer</div>
    <v-spacer></v-spacer>
    <a href="https://www.linkedin.com/in/hschmieding/" target="_blank">
      <v-img
        alt="LinkedIn"
        class="shrink mr-2 logo"
        contain
        src="../assets/linkedIn.png"
        transition="scale-transition"
        width="40"
        title="LinkedIn"
      />
    </a>
    <a href="https://ariak.dev" target="_blank">
      <v-img
        alt="Author Logo"
        class="shrink mr-2 logo"
        contain
        src="../assets/ariak-icon.png"
        transition="scale-transition"
        width="40"
        title="ariak.dev | Hannes 'Ariak' Schmieding"
      />
      
    </a>
    <div class="caption">by Hannes "Ariak" Schmieding</div>
  </v-app-bar>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
.logo {
  border-radius: 10%;
}
</style>


